export default "__VITE_ASSET__3fac1465__"